// https://vuex.vuejs.org/en/state.html

export default {
  token: window.localStorage.getItem("token") | null,
};
